import styled from "styled-components";
import { viewSizeCalculator } from "../../utils";

export const MainWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    border: 1px solid black;
`;

export const Wrapper = styled.div`
    width: ${() => `${viewSizeCalculator(50.5)}`};
    height: ${() => `${viewSizeCalculator(36.9375)}`};

    display:flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`

export const Button = styled.button`
    width: ${() => `${viewSizeCalculator(9.375)}`};
    height: ${() => `${viewSizeCalculator(2.5)}`};
    border-radius: ${() => `${viewSizeCalculator(1.25)}`};
    text-align: center;
    padding : ${() => `${viewSizeCalculator(0.5)} ${viewSizeCalculator(0.75)}`};
    
    font-family: Inter;
    font-weight: 500;
    font-size:${() => `${viewSizeCalculator(0.8125)}`};

    background-color: #333333;
    color: #FFFFFF;

    cursor: pointer;
`
